import { render } from "./PhonenumberView.vue?vue&type=template&id=893183b8&scoped=true"
import script from "./PhonenumberView.vue?vue&type=script&lang=js"
export * from "./PhonenumberView.vue?vue&type=script&lang=js"

import "./PhonenumberView.vue?vue&type=style&index=0&id=893183b8&lang=css"
import "./PhonenumberView.vue?vue&type=style&index=1&id=893183b8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-893183b8"]])

export default __exports__